module.exports = __webpack_public_path__ + "media/images/mayotte-5ff608210e3f5ec565eb5969d0555273.svg";